module.exports = __webpack_public_path__ + "img/mobilehardware5.65fa01ea.png";